export const MaskedDirective = {
  bind (el, binding) {
    el.addEventListener('blur', function () {
      el.type = 'password'
    })

    el.addEventListener('focus', function () {
      el.type = binding.value.type
    })
  }
}
